import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-6 col-12" }
const _hoisted_5 = {
  key: 0,
  class: "mb-0 text-title-gray"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-0 text-title-gray"
}
const _hoisted_7 = {
  key: 2,
  class: "mb-0 text-title-gray"
}
const _hoisted_8 = { class: "col-sm-6 col-12" }
const _hoisted_9 = { class: "breadcrumb" }
const _hoisted_10 = { class: "breadcrumb-item" }
const _hoisted_11 = { class: "breadcrumb-item" }
const _hoisted_12 = { class: "breadcrumb-item active" }



export default /*@__PURE__*/_defineComponent({
  __name: 'BreadCrumbs',
  props: {
    title: {
        default: 'home'
    },
    main: {
        default: ''
    },
    mains: {
        default: ''
    },
    defaultdesc: String,
    ecommorcedesc: String,
    educationdesc: String
},
  setup(__props) {

let props = __props

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(__props.mains), 1),
          (__props.defaultdesc)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Welcome back! Let’s start from where you left."))
            : _createCommentVNode("", true),
          (__props.ecommorcedesc)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, "\"Welcome back! Continue your journey.\""))
            : _createCommentVNode("", true),
          (__props.educationdesc)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, "\"Welcome back to your educational adventure!\""))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("ol", _hoisted_9, [
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("i", { class: "iconly-Home icli svg-color" }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_11, _toDisplayString(__props.main), 1),
            _createElementVNode("li", _hoisted_12, _toDisplayString(__props.title), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})